module.exports = {"type":"text","name":"singleNodeValues","from":{"data":"singleNodeSymbols"},"encode":{"enter":{"text":{"value":"1"},"align":{"value":"center"},"baseline":{"value":"middle"},"fontSize":{"value":6}},"update":{"x":{"field":"x"},"y":{"field":"y"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/single-nodes/value.json
// module id = dYCV
// module chunks = 0